import { Select, SelectOption } from "@clockwise/design-system";
import { OrdinalModifierEnum } from "@clockwise/schema";
import pluralize from "pluralize";
import React, { useEffect, useState } from "react";
import { useUpdateEventSearchFilters } from "../../../../hooks/event-search-filters/useUpdateEventSearchFilters";
import { GQLOrdinalModifier } from "../../../../utils/types";
import { BaseChip } from "./BaseChip";

const OrdinalSelect = ({
  value,
  disabled = false,
  onChange,
}: {
  value: OrdinalModifierEnum;
  onChange: (value: OrdinalModifierEnum) => void;
  disabled?: boolean;
}) => {
  return (
    <Select
      showExpandIcon
      size={"mini"}
      value={value}
      variant="inline"
      disabled={disabled}
      onChange={onChange}
    >
      <SelectOption value={OrdinalModifierEnum.ALL}> All</SelectOption>
      <SelectOption value={OrdinalModifierEnum.NEXT}> Next</SelectOption>
      <SelectOption value={OrdinalModifierEnum.FIRST}> First</SelectOption>
      <SelectOption value={OrdinalModifierEnum.LAST}> Last</SelectOption>
    </Select>
  );
};
export const OrdinalModifier = ({
  ordinal,
  modifier,
  disabled,
  eventSearchBlockId,
  conversationId,
}: {
  ordinal: number | null;
  modifier: OrdinalModifierEnum;
  disabled: boolean;
  eventSearchBlockId: string;
  conversationId: string;
}) => {
  const { updateOrdinalModifier } = useUpdateEventSearchFilters();
  const [localModifier, setLocalModifier] = useState<OrdinalModifierEnum>(modifier);
  const isPlural =
    localModifier === OrdinalModifierEnum.ALL ||
    localModifier === OrdinalModifierEnum.NTH ||
    ((localModifier === OrdinalModifierEnum.FIRST ||
      localModifier === OrdinalModifierEnum.LAST ||
      localModifier === OrdinalModifierEnum.NEXT) &&
      !!ordinal);

  const onChangeOrdinalModifier = (value: OrdinalModifierEnum) => {
    setLocalModifier(value);
    const newOrdinalFilter: GQLOrdinalModifier = {
      __typename: "EventSearchOrdinalModifier",
      ordinal: ordinal,
      modifier: value,
    };
    updateOrdinalModifier(eventSearchBlockId, conversationId, newOrdinalFilter);
  };

  useEffect(() => {
    setLocalModifier(modifier);
  }, [modifier, ordinal, disabled]);

  return (
    <BaseChip disabled={disabled}>
      <div className="cw-flex cw-items-center">
        <span className="cw-mr-1 -cw-my-0.5">
          <OrdinalSelect
            value={localModifier}
            disabled={disabled}
            onChange={onChangeOrdinalModifier}
          />
        </span>
        {ordinal ?? ""}
        {pluralize(" meeting", isPlural ? 2 : 1)}
      </div>
    </BaseChip>
  );
};
